<script>
  import { onMount } from 'svelte';
  import { format } from 'svelte-i18n';

  import { loadNewBizcardModalTemplates } from '@client/stores/bizcard-templates';
  import { isGoogle } from '@client/stores/domain-settings';
  import { userStore } from '@client/stores/user';

  export let onSelect = () => {};

  let previewTemplates = [];

  const formatTemplate = (template) => {
    return template
      .replace(/\{\{\s*platform\s*\}\}/g, $isGoogle ? 'google' : 'office365')
      .replace(/\{\{\s*domain\s*\}\}/g, $userStore.domain);
  };

  onMount(async () => {
    previewTemplates = await loadNewBizcardModalTemplates();
  });
</script>

<p>{$format('label.BIZCARD_NEW_CARD_MODAL_DESCRIPTION')}</p>

<div class="business-card-templates">
  {#each previewTemplates as template, index}
    <div class="preview">
      <h4 class="text-capitalize">{template.name}</h4>
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
        class="business-card-template"
        data-testid="business-card-template-{index}"
        role="button"
        tabindex="0"
        on:click={() => onSelect(template)}
      >
        <div class="card-wrapper">
          <iframe
            role="button"
            scrolling="no"
            srcdoc="<html><body><div>{formatTemplate(template.html)}</div></body></html>"
            tabindex="-1"
            title={template.name}
          />
        </div>
      </div>
    </div>
  {/each}
</div>

<style lang="scss" src="./layout.scss"></style>
